import { jsx as _jsx } from "react/jsx-runtime";
import { ellipsisStyle } from "./Ellipsis.js";
import React from "react";
import { Tooltip } from "@mui/material";
export const TextWithOverflow = ({ children }) => {
    const [isOverflow, setIsOverflow] = React.useState(false);
    return (_jsx(Tooltip, { title: children && isOverflow ? children : "", arrow: true, placement: "top", children: _jsx("span", { ref: ref => {
                const newIsOverflow = Boolean(ref && ref.scrollWidth > ref.clientWidth);
                if (newIsOverflow !== isOverflow)
                    setIsOverflow(newIsOverflow);
            }, style: { display: "block", width: "100%", ...ellipsisStyle }, children: children }) }));
};
//# sourceMappingURL=TextWithOverflow.js.map